export default "__VITE_ASSET__OZX$bqYp__"